import axios from 'axios';
import { ITipState } from './type';
import { transformTipConfigForState, transformTipConfigForApi } from './transformer';

export const endpoints = {
  tipConfiguration: '/admin/settings/tip',
};

export const fetchTipConfiguration = async (): Promise<ITipState> => {
  const {
    data: { data },
  } = await axios.get(endpoints.tipConfiguration);

  return transformTipConfigForState(data);
};

export const putTipConfiguration = async (payload: ITipState): Promise<ITipState> => {
  const internalPayload = transformTipConfigForApi(payload);
  const {
    data: { data },
  } = await axios.put(endpoints.tipConfiguration, internalPayload);
  return transformTipConfigForState(data);
};
